import { TypedUseSelectorHook, useSelector } from "react-redux";
import {
  PssLayoutStoreSlice,
  pssAuthReducer,
  pssLayoutReducer,
} from "../features";
import { PssAuthStoreSlice } from "../features/authentication/datasources/_pss.auth.store.slice";
import { pssApiSlicev1 } from "./_pss.apis.v1";

export interface PssStoreSlices {
  pssLayout: PssLayoutStoreSlice;
  pssAuth: PssAuthStoreSlice;
}

export const pssReducers = {
  pssLayout: pssLayoutReducer,
  pssAuth: pssAuthReducer,
  [pssApiSlicev1.reducerPath]: pssApiSlicev1.reducer,
};

export const usePssTypedSelector: TypedUseSelectorHook<PssStoreSlices> =
  useSelector;

export const pssApiMiddlewares = [pssApiSlicev1.middleware];
